// CI/CD pipeline test - 2026-01-15
import React from 'react';
import ReactDOM from 'react-dom/client';
import axios from 'axios';

import App from './App';
import { TooltipProvider } from '@/components/ui/tooltip';
import { getActiveWorkspaceId } from '@/stores/workspace-store';
import { analytics } from '@lib/analytics';
import './styles/globals.css';

// Initialize all analytics providers (PostHog + GTM) before React renders
analytics.init();

// Global axios interceptor: adds X-Workspace-Id header to our API requests
// This ensures multi-workspace support works across all API clients
const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3001';
axios.interceptors.request.use((config) => {
  // Only add header for requests to our backend (not external APIs)
  const isOurApi = config.url?.startsWith(API_URL) || config.url?.startsWith('/api');
  if (isOurApi) {
    const workspaceId = getActiveWorkspaceId();
    if (workspaceId && !config.headers['X-Workspace-Id']) {
      config.headers['X-Workspace-Id'] = workspaceId;
    }
  }
  return config;
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <TooltipProvider>
      <App />
    </TooltipProvider>
  </React.StrictMode>,
);